export * from '@taqueria/protocol/out/types/PublicKeyHash';
